import styled from "styled-components"

const AccesDirectItemSvg = styled.img`
  fill: ${(props) => props.theme.c_color_gradients.c_dark};
`

export { AccesDirectItemSvg }
